var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowmixUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 210,
    viewBox: "0 0 210 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h170v170H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 210,
    fill: "gray",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    d: "M149.699 35.74c-7.918-2.486-16.62-3.55-24.965-3.55-13.91 0-28.888 2.84-39.231 10.65-10.343-7.81-25.322-10.65-39.23-10.65-13.91 0-28.889 2.84-39.232 10.65v104.024c0 1.775 1.784 3.55 3.567 3.55.713 0 1.07-.355 1.783-.355 9.63-4.615 23.539-7.81 33.881-7.81 13.91 0 28.888 2.84 39.231 10.65 9.63-6.035 27.105-10.65 39.23-10.65 11.77 0 23.896 2.13 33.882 7.455.713.355 1.07.355 1.783.355 1.783 0 3.566-1.775 3.566-3.55V42.84c-4.28-3.195-8.916-5.325-14.265-7.1zm0 95.858c-7.846-2.486-16.406-3.55-24.965-3.55-12.126 0-29.602 4.615-39.231 10.65V57.041c9.63-6.035 27.105-10.65 39.23-10.65 8.56 0 17.12 1.065 24.966 3.55v81.657z",
    mask: "url(#b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowmixUnavailable);
export default __webpack_public_path__ + "static/media/knowmix_unavailable.d17a64e1f20cc02b5abda59382538c3c.svg";
export { ForwardRef as ReactComponent };